// extracted by mini-css-extract-plugin
export default {"imageWrapper":"mM-z","twoColumnImage":"nM-z"};